/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *
 *
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 *
 *
 */

/**
 * @module bulb-media-embed/bulbmediaembedcommand
 */

import {
  Command, type ModelWriter, type ModelElement, type ModelPosition,
} from 'ckeditor5';

/**
 * The bulb media embed command, the actual insert capabilities of the plugin.
 *
 * @extends Command
 */
export class InsertBulbMediaEmbedCommand extends Command {

  static createEmbedBlock(writer: ModelWriter, blockDetails: { id: any; version: any; }): ModelElement {
    return writer.createElement(
      'embed',
      {
        'bulb-block-id': blockDetails.id,
        'bulb-block-version': blockDetails.version,
      },
    );
  }

  public override execute(blockDetails, placeholderElement: ModelElement, insertPosition: ModelPosition): void {
    this.editor.model.change((writer: ModelWriter) => {
      this.editor.model.insertContent(
        InsertBulbMediaEmbedCommand.createEmbedBlock(writer, blockDetails),
        insertPosition,
      );
      CKEBulbData.service.ckeStateService.handleSaveOperation.next(true);
      CKEBulbData.service.ckeStateService.insertParagraphSubject.next(true);

      if (placeholderElement) {
        writer.remove(placeholderElement);
      }
    });
  }

  public override refresh(): void {
    const { model } = this.editor;
    const { selection } = model.document;
    const allowedIn = model.schema.findAllowedParent(selection.getFirstPosition(), 'embed');

    this.isEnabled = allowedIn !== null;
  }
}
